/*
 * @Author: your name
 * @Date: 2021-05-26 08:58:52
 * @LastEditTime: 2021-05-31 17:44:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \hangxintong-tools-h5\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// 实名认证路由
import realNameAuthenticationRouter from './modules/realNameAuthentication'
import knowledgeLibrary from './modules/knowledgeLibrary'
// 消息
import notification from './modules/notification'
export default new Router({
  base: '/',
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    // 人脸认证
    ...realNameAuthenticationRouter,
    // 知识库
    ...knowledgeLibrary,
    // 消息
    ...notification,
    {
      path: '/certificateQuery', // 证书查询系统
      name: 'query',
      component: () => import('@/pages/certificateQuery/index.vue')
    },
    {
      path: '/specialOperations', // 特种作业学员学习情况查询
      name: 'query',
      component: () => import('@/pages/specialOperations/index.vue')
    },
    {
      path: '/verify/:id',
      name: 'verify',
      component: () => import('@/pages/verify/index.vue')
    },
    {
      path: '/cert/:certid',
      name: 'cert',
      component: () => import('@/pages/cert/index.vue')
    },
    
    {
      path: '/',
      name: 'member',
      component: () => import('@/pages/member/index.vue')
    },
    {
      path: '/member/register',
      // path: '/',
      name: 'register',
      component: () => import('@/pages/member/register.vue')
    },
    {
      path: '/member/registerPc',
      component: () => import('@/pages/member/registerPc.vue')
    },
    {
      path: '/member/registerSuccess',
      name: 'registerSuccess',
      component: () => import('@/pages/member/registerSuccess.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/login/index.vue')
    },
    {
      path: '/login/register',
      name: 'Register',
      component: () => import('@/pages/login/register.vue')
    },
    {
      path: '/forget',
      name: 'Forget',
      component: () => import('@/pages/login/forget.vue')
    },
    {
      path: '/ids/investigation/:id', //调研
      name: 'investigation',
      component: () => import('@/pages/ivg/index.vue')
    },
    {
      path: '/ids/dc/:id', //采集
      name: 'collection',
      component: () => import('@/pages/collection/index.vue')
    },
    {
      path: '/knowledgeLibrary', // 知识库
      name: 'knowledgeLibrary',
      component: () => import('@/pages/knowledgeLibrary/index.vue'),
    },
    {
      path: '/knowledgeLibrary/myKnowledge', //  我投稿的知识
      name: 'myKnowledge',
      component: () => import('@/pages/knowledgeLibrary/myKnowledge/index.vue')
    },
    {
      path: '/knowledgeLibrary/library/:id', // 知识库 专题知识列表
      name: 'library',
      component: () => import('@/pages/knowledgeLibrary/library/index.vue'),

    },
    {
      path: '/anzexian', // 安责险
      name: 'anzexian',
      component: () => import('@/pages/anzexian/index.vue'),

    },

    {
      path: '/anzexian/formInfo', // 安责险保单详情
      name: 'formInfo',
      component: () => import('@/pages/anzexian/formInfo'),
    },

    {
      path: '/anzexian/demandInfo', // 安责险保险需求详情
      name: 'demandInfo',
      component: () => import('@/pages/anzexian/demandInfo'),
    },
    {
      path: '/login/login', // 知识库 专题知识列表
      name: 'login',
      component: () => import('@/pages/login/login.vue'),

    },
    // 登录协议
    {
      path: '/agreement', // 登录协议
      name: 'agreement',
      component: () => import('@/pages/login/compoents/agreement.vue'),

    },
    // 用户隐私
    {
      path: '/policy', // 用户隐私
      name: 'policy',
      component: () => import('@/pages/login/compoents/policy.vue'),

    },

    // 消息
    {
      path: '/message/info', // 消息
      name: 'message',
      component: () => import('@/pages/message/info/index.vue'),

    },
    // 培训H5授权
    {
      path: '/uniTrain',
      name: 'uniTrain',
      component: () => import('@/pages/uniTrain/index.vue')
    },
    // 五大员证书查询
    {
      path: '/fiveMajorCert',
      name: 'fiveMajorCert',
      component: () => import('@/pages/fiveMajorCert/index.vue')
    },
    // 五大员注册
    {
      path: '/fiveMajorCert/register',
      name: 'fiveMajorCert/register',
      component: () => import('@/pages/fiveMajorCert/register/index.vue')
    },
    // 五大员工作台
    {
      path: '/fiveMajorCert/fiveMajor',
      name: 'fiveMajorCert/fiveMajor',
      component: () => import('@/pages/fiveMajorCert/fiveMajor/index.vue')
    },
    // 五大员更换企业
    {
      path: '/fiveMajorCert/fiveMajor/replaceCompany',
      name: 'fiveMajorCert/fiveMajor/replaceCompany',
      component: () => import('@/pages/fiveMajorCert/fiveMajor/replaceCompany/index.vue')
    },
    // 五大员更换企业详情
    {
      path: '/fiveMajorCert/fiveMajor/replaceCompany/detail',
      name: 'fiveMajorCert/fiveMajor/replaceCompany/detail',
      component: () => import('@/pages/fiveMajorCert/fiveMajor/replaceCompany/detail.vue')
    },
    // 证书V2采集
    {
      path: '/certV2',
      name: 'certV2',
      component: () => import('@/pages/certV2/index.vue')
    },

    // 证书V2--我的证书
    {
      path: '/certV2/myCert',
      name: 'certV2/myCert',
      component: () => import('@/pages/certV2/myCert/index.vue')
    },

    // 证书V2--证书列表
    {
      path: '/certV2/myCert/list',
      name: 'certV2/myCert/list',
      component: () => import('@/pages/certV2/myCert/list.vue')
    },

    // 证书V2--登录
    {
      path: '/certV2/login/index',
      name: 'certV2/login/index',
      component: () => import('@/pages/certV2/login/index.vue')
    },
    // 证书V2--手机号登录
    {
      path: '/certV2/login/login',
      name: 'certV2/login/login',
      component: () => import('@/pages/certV2/login/login.vue')
    },
    // 证书V2--注册
    {
      path: '/certV2/login/register',
      name: 'certV2/login/register',
      component: () => import('@/pages/certV2/login/register.vue')
    },
    // 证书V2--身份校验
    {
      path: '/certV2/check/index',
      name: '/certV2/check/index',
      component: () => import('@/pages/certV2/check/index.vue')
    },
    //  证书V2--查询证书
    {
      path: '/certV2/certificateQuery',
      name: '/certV2/certificateQuery',
      component: () => import('@/pages/certV2/certificateQuery/index.vue')
    },
    //  证书V2.1--查询电子证照详情
    {
      path: '/certV2/check/templateImg',
      name: '/certV2/check/templateImg',
      component: () => import('@/pages/certV2/check/templateImg.vue')
    },
    //  证书V2.2--提交采集成功页面
    {
      path: '/certV2/success',
      name: '/certV2/success',
      component: () => import('@/pages/certV2/success.vue')
    },


    //  通用支付路由
    {
      path: '/pay',
      name: '/pay',
      component: () => import('@/pages/pay/index.vue')
    },

    // {
    //   path: '/',
    //   name: '404',
    //   component: import('@/components/page404')
    // },
    {
      path: '/:certid',
      name: 'certId',
      component: () => import('@/pages/cert/index.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js